import { useRef, type KeyboardEvent } from 'react';

import {
    applicationScreens,
    type ApplicationScreen,
    type OpenWelcomeDialog,
} from './data';

type Props = {
    screen: ApplicationScreen;
    selectScreen: (screen: ApplicationScreen) => void;
    openDialog: OpenWelcomeDialog;
};

export function ApplicationPreview({
    screen,
    selectScreen,
    openDialog,
}: Props) {
    const tabs = useRef<(HTMLButtonElement | null)[]>([]);

    function handleKey(event: KeyboardEvent<HTMLButtonElement>, index: number) {
        let destination: number | undefined;
        if (event.key === 'ArrowRight')
            destination = (index + 1) % applicationScreens.length;
        if (event.key === 'ArrowLeft')
            destination =
                (index - 1 + applicationScreens.length) %
                applicationScreens.length;
        if (event.key === 'Home') destination = 0;
        if (event.key === 'End') destination = applicationScreens.length - 1;
        if (destination === undefined) return;
        event.preventDefault();
        selectScreen(applicationScreens[destination]);
        tabs.current[destination]?.focus();
    }

    return (
        <figure className="product-preview app-preview feature-preview">
            <div
                className="app-preview-tabs"
                role="tablist"
                aria-label="Recursos da Servion"
            >
                {applicationScreens.map((item, index) => (
                    <button
                        key={item.id}
                        id={`${item.id}-tab`}
                        type="button"
                        role="tab"
                        ref={(element) => {
                            tabs.current[index] = element;
                        }}
                        aria-selected={screen.id === item.id}
                        aria-controls="app-screen-panel"
                        tabIndex={screen.id === item.id ? 0 : -1}
                        data-app-screen={item.id}
                        onClick={() => selectScreen(item)}
                        onKeyDown={(event) => handleKey(event, index)}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            <div
                id="app-screen-panel"
                role="tabpanel"
                aria-labelledby={`${screen.id}-tab`}
            >
                <button
                    className="app-screen-open"
                    type="button"
                    aria-label="Ampliar o recurso da aplicação"
                    onClick={(event) =>
                        openDialog('product-image-dialog', event.currentTarget)
                    }
                >
                    <img
                        id="app-screen-image"
                        src={screen.src}
                        width={screen.width}
                        height={screen.height}
                        alt={screen.alt}
                    />
                </button>
            </div>
            <figcaption>
                <span>Recurso real · dados de demonstração</span>
                <button
                    className="text-link"
                    type="button"
                    onClick={(event) =>
                        openDialog('product-image-dialog', event.currentTarget)
                    }
                >
                    Ver detalhe <span aria-hidden="true">↗</span>
                </button>
            </figcaption>
        </figure>
    );
}
